import React from "react";
import { mergeStyles } from "office-ui-fabric-react";
import { mergeStyleSets } from "office-ui-fabric-react";

interface IProps {
    id: string,
    title: string,
    className?: string,
    showModalHeader?: boolean,
    children: React.ReactNode;
}


const classes = mergeStyleSets({
    formContainer: { display: "flex", flexDirection: "column", height: "100%" },
    formHeader: {
        gap: 8,
        padding: "0px 16px 16px 16px",
        display: "flex",
        alignItems: "center",
        backgroundColor: "white",
    },
    formHeaderTitle: {
        fontWeight: 700,
        fontSize: 20,
        lineHeight: "24px",
        letterSpacing: "0.005em",
        color: "#4C4C4C",
    },
    toolbarSeparator: {
        height: "40px",
        width: "1px",
        background: "#D8DFE6",
        margin: "0",
    },
    modal: {
        border: "0",
        boxShadow: "0 0 1em rgb(0 0 0 /.3)"
    },
});
const buttonIcon = mergeStyles({
    padding: "9px 10px",
    fontSize: 16,
    fontWeight: 500,
    height: 40,
    width: 40,
    justifyContent: "center",
    border: "1px solid #D8DFE6",
    borderRadius: "2px",
    display: "flex",
    alignItems: "center",
    color: "#4c4c4c",
    selectors: {
        [":active"]: {
            backgroundColor: "#008cc0",
        },
    },
});
const Modal: React.FC<IProps> = ({ id, title, className, showModalHeader = true, children }: IProps) => {

    const close = () => {
        const modal = document.getElementById(id) as HTMLDialogElement;
        modal.close();
    };


    return (<>
        <dialog data-modal id={id} className={className ?? classes.modal}>
            <div>
                {showModalHeader &&
                    <div className={classes.formHeader}>
                        <span className={classes.formHeaderTitle}>{title}</span>
                        <div style={{ flexGrow: 1 }}></div>
                        <div className={classes.toolbarSeparator}></div>
                        <button
                            id="btn-close"
                            type="button"
                            className={buttonIcon}
                            onClick={close}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                            >
                                <path
                                    d="M0.589143 0.715991L0.646143 0.645991C0.728999 0.563315 0.838234 0.512329 0.954817 0.501913C1.0714 0.491497 1.18794 0.522313 1.28414 0.588991L1.35414 0.645991L6.00014 5.29299L10.6461 0.645991C10.74 0.552104 10.8674 0.499359 11.0001 0.499359C11.1329 0.499359 11.2603 0.552104 11.3541 0.645991C11.448 0.739877 11.5008 0.867215 11.5008 0.999991C11.5008 1.13277 11.448 1.2601 11.3541 1.35399L6.70714 5.99999L11.3541 10.646C11.4368 10.7288 11.4878 10.8381 11.4982 10.9547C11.5086 11.0712 11.4778 11.1878 11.4111 11.284L11.3541 11.354C11.2713 11.4367 11.1621 11.4877 11.0455 11.4981C10.9289 11.5085 10.8123 11.4777 10.7161 11.411L10.6461 11.354L6.00014 6.70699L1.35414 11.354C1.26026 11.4479 1.13292 11.5006 1.00014 11.5006C0.867368 11.5006 0.74003 11.4479 0.646143 11.354C0.552257 11.2601 0.499512 11.1328 0.499512 11C0.499512 10.8672 0.552257 10.7399 0.646143 10.646L5.29314 5.99999L0.646143 1.35399C0.563468 1.27114 0.512481 1.1619 0.502066 1.04532C0.49165 0.928733 0.522465 0.81219 0.589143 0.715991Z"
                                    fill="#4C4C4C"
                                />
                            </svg>
                        </button>
                    </div>
                }
                {children}
            </div>
            
        </dialog></>)
};

export default Modal;